<template>
  <div class="caution">
    <div class="caution__intro">
      <i class="icon icon--ab--text-reg"></i>
    </div>
    <div class="caution__title">
      <div class="page1" v-if="page === 'page1'" v-html="$t('ab.caution.page1.title')"></div>
      <div class="page2" v-if="page === 'page2'" v-html="$t('ab.caution.page2.title')"></div>
    </div>
    <div class="caution__desc">
      <div class="page1" v-if="page === 'page1'">
        {{ $t('ab.caution.page1.desc') }}
      </div>
      <div class="page2" v-if="page === 'page2'">
        {{ $t('ab.caution.page2.desc') }}
      </div>
    </div>
    <div class="caution__btns">
      <template v-if="page === 'page1'">
        <ui-button @click="$emit('closePopup')" size="large">{{
          $t('common.cancel')
        }}</ui-button>
        <ui-button primary2 @click="page = 'page2'" size="large">{{
          $t('common.next')
        }}</ui-button>
      </template>
      <template v-if="page === 'page2'">
        <ui-button @click="$emit('closePopup')" size="large">{{
          $t('common.cancel')
        }}</ui-button>
        <ui-button primary @click="$emit('confirm')" size="large">{{
          $t('common.confirm')
        }}</ui-button>
      </template>
    </div>
  </div>
</template>

<script>
import UiButton from '@/components/ui/UiButton'
export default {
  components: {
    UiButton
  },
  data () {
    return {
      page: 'page1'
    }
  },
  methods: {}
}
</script>

<style lang="scss" scoped>
.caution {
  position: relative;
  display: flex;
  flex-direction: column;
  row-gap: 12px;

  box-sizing: border-box;
  width: 430px;
  height: 350px;
  padding: 50px 40px 25px;
  border-radius: 14px;

  background-color: #fff;

  &__intro {
    display: flex;
    justify-content: center;
  }

  &__title {
    font-size: 20px;
    font-weight: 500;
    font-stretch: normal;
    font-style: normal;
    line-height: 1.25;
    letter-spacing: normal;
    text-align: center;
    color: #444;
  }

  &__desc {
    font-size: 14px;
    font-weight: normal;
    font-stretch: normal;
    font-style: normal;
    line-height: 1.43;
    letter-spacing: normal;
    text-align: center;
    color: #2f2f2f;
  }

  &__btns {
    position: absolute;
    left: 0px;
    bottom: 25px;
    display: flex;
    justify-content: center;
    column-gap: 5px;

    width: 100%;
  }
}
</style>
